var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTempCheck = function SvgTempCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 32,
    viewBox: "0 0 17 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 24C11.5 22.75 10.625 21.625 9.5 21.1875V13C9.5 12.5 9 12 8.5 12C7.9375 12 7.5 12.5 7.5 13V21.1875C6.3125 21.625 5.5 22.75 5.5 24C5.5 25.6875 6.8125 27 8.5 27C10.125 27 11.5 25.6875 11.5 24ZM14.5 18.75V6C14.5 2.6875 11.8125 0 8.5 0C5.125 0 2.5 2.6875 2.5 6V18.75C1.25 20.125 0.5 22 0.5 24C0.4375 28.375 4 32 8.4375 32C8.4375 32 8.4375 32 8.5 32C12.875 32 16.5 28.4375 16.5 24C16.5 22 15.6875 20.125 14.5 18.75ZM14.5 24C14.5 27.3125 11.75 30 8.5 30H8.4375C5.125 30 2.4375 27.3125 2.5 24C2.5 21.5625 3.875 20.1875 4.5 19.5V6C4.5 3.8125 6.25 2 8.5 2C10.6875 2 12.5 3.8125 12.5 6V19.5C13.0625 20.125 14.5 21.5625 14.5 24Z",
    fill: "#605FF3"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTempCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tempCheck.9197b048.svg";
export { ForwardRef as ReactComponent };